import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const NoInternet = () => {
  const routes = all_routes;

  return (
    <div className="container">
      <div className="vh-100 d-flex align-items-center justify-content-center">
        <div className="row w-100">
          {/* Left Panel - Message */}
          <div className="col-md-12 d-flex flex-column justify-content-center align-items-center text-center">
            <div className="mb-4">
              <img
                src="./assets/img/logo/weconnectlogo.png"
                alt="WeConnect Logo"
                className="img-fluid"
                style={{ maxWidth: "180px" }}
              />
            </div>
            <h1 className="mb-3 fw-bold text-warning">No Internet Connection</h1>
            <p className="fs-10 text-muted px-3">
              It seems you’re offline. Please check your network connection and try again. 
              If you continue to experience issues, contact your administrator.
            </p>

            <button
              className="btn btn-primary custom_button mt-4 d-flex align-items-center"
              onClick={() => window.location.reload()}
            >
              <i className="ti ti-refresh me-2" />
              Retry Connection
            </button>

            <Link
              to={routes.employeeDashboard}
              className="btn btn-outline-secondary mt-3 d-flex align-items-center"
            >
              <i className="ti ti-home me-2" />
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoInternet;
